module.exports = __webpack_public_path__ + "static/gallery-22-c5b135a120c6d830200b0d5ceffb2b14.jpg";